<!--
 * @Description: file content
 * @Author: liujunyao
 * @Date: 2022-03-28 13:45:01
 * @LastEditors: liujunyao
 * @LastEditTime: 2022-04-22 10:47:30
 * @FilePath: /privacy-web/src/components/The/TheFooter.vue
-->
<template>
  <div class="footer-main" :class="{ 'footer-main-mobile': isMobile }">
    <The-footer-navigation></The-footer-navigation>
    <The-filing></The-filing>
  </div>
</template>
<script>
export default { name: "TheFooter" };
</script>
<style lang="scss" scoped>
.footer-main {
  width: 100%;
  height: calc($multiple * 134px);
  background: #011327;
}
.footer-main-mobile {
  height: 6.09rem;
}
</style>
